window.timberSlider = window.timberSlider || {};

timberSlider.cacheSelectors = function () {
  timberSlider.cache = {
    // Home Page
    $slider: $('.flexslider')
  }
};

timberSlider.init = function () {
  timberSlider.cacheSelectors();
  timberSlider.sliders();
};

timberSlider.sliders = function () {
  var $slider = timberSlider.cache.$slider,
      sliderArgs = {
        animation: 'fade',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: true,
        directionNav: true,
        touch: true,
        slideshow: true,
        slideshowSpeed: 5000,
        controlNav: false,
        after: function($slider){
          var curSlide = $slider.find("li.flex-active-slide");
          var bg_class = $(curSlide).attr('data-color');
          var bg_nav_class = $(curSlide).attr('data-nav-color');
          $('body').removeClass('is-light');
          $('body').removeClass('is-dark');
          $('body').removeClass('is-light-nav');
          $('body').removeClass('is-dark-nav');
          $('body').addClass(bg_class); 
          $('body').addClass(bg_nav_class); 
    	}     
      }; 

  if ($slider.length) {

    if ($slider.find('li').length === 1) {
      sliderArgs.slideshow = false;
      sliderArgs.slideshowSpeed = 0;
      sliderArgs.controlNav = false;
      sliderArgs.directionNav = true;
      sliderArgs.touch = false;
    }

    $slider.flexslider(sliderArgs);
    
  }
};

// Initialize slider on docready
$(window).on('load', function() {
  // Add this verification to avoid replace body class on home-featured-video.liquid
  var isVideo = $('.hero').has('#video-bg').length;
  if (!isVideo) {
    $('body').removeClass('is-light');
    $('body').removeClass('is-dark');
    $('body').removeClass('is-light-nav');
    $('body').removeClass('is-dark-nav');
    
    if($(window).width() < 769){
      var curSlide = $('.flexslider.mobile').find("li").first();
    }
    else{
       var curSlide = $('.flexslider.desktop').find("li").first();
    }
    var bg_class = $(curSlide).attr('data-color');
    var bg_nav_class = $(curSlide).attr('data-nav-color');
    $('body').addClass(bg_class);  
    $('body').addClass(bg_nav_class);  
    
    timberSlider.init();
  }  
});
